import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-envio-email',
	standalone: true,
	imports: [
		CommonModule,
		CaLabel,
		CaInputDirective,
		CaFormFieldComponent,
		ReactiveFormsModule,
		TranslateModule
	],
	templateUrl: './envio-email.component.html',
	styleUrls: ['./envio-email.component.scss']
})
export class EnvioEmailComponent implements OnInit{
	@Input() form: FormGroup;

	constructor(private fb: FormBuilder) { }
	
	ngOnInit(): void {
		if (!this.form) {
			this.form = this.fb.group({});
		}

		this.form.addControl('envio-email-tomador', this.fb.control(''));
		this.form.addControl('envio-email-mediador', this.fb.control(''));
	}
	
 }
